import React from "react";
import { motion } from "framer-motion";
import { Shield, CheckCircle, AlertCircle, XCircle } from "lucide-react";

const StatsCards = ({ statsData }) => {
  // Default stats if not provided
  const stats = statsData || {
    total_sender_ids: 0,
    total_approved: 0,
    total_pending: 0,
    total_rejected: 0
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.1 }}
      className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8"
    >
      {/* Total Sender IDs */}
      <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow duration-300">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">
              Total Sender IDs
            </p>
            <p className="text-2xl sm:text-3xl font-bold text-gray-900">
              {stats.total_sender_ids || 0}
            </p>
          </div>
          <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center">
            <Shield className="w-6 h-6 text-gray-600" />
          </div>
        </div>
      </div>

      {/* Approved */}
      <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow duration-300">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Approved</p>
            <p className="text-2xl sm:text-3xl font-bold text-green-600">
              {stats.total_approved || 0}
            </p>
          </div>
          <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center">
            <CheckCircle className="w-6 h-6 text-green-600" />
          </div>
        </div>
      </div>

      {/* Pending */}
      <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow duration-300">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Pending</p>
            <p className="text-2xl sm:text-3xl font-bold text-amber-600">
              {stats.total_pending || 0}
            </p>
          </div>
          <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center">
            <AlertCircle className="w-6 h-6 text-amber-600" />
          </div>
        </div>
      </div>

      {/* Rejected */}
      <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow duration-300">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Rejected</p>
            <p className="text-2xl sm:text-3xl font-bold text-red-600">
              {stats.total_rejected || 0}
            </p>
          </div>
          <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center">
            <XCircle className="w-6 h-6 text-red-600" />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default StatsCards;